export default __webpack_public_path__ + "static/bagic_hindi-04a3d28ed42178cc569a7e7591918f24.jpg";